// ─── qcApi ──────────────────────────────────────────────────────────────────
// Requests for the QC module's own endpoints, all under /api/qc/**.
//
// Every call goes through the shared apiFetch helper with area: 'qc', so it
// uses the QC token (saved as 'qcToken'), never the customer token. If the
// QC sign-in has expired, apiFetch sends the reviewer to /qc/login and brings
// them back here afterwards.

import { apiFetch } from '../../api/apiClient';

const qc = (path, options = {}) => apiFetch(`/api/qc${path}`, { ...options, area: 'qc' });

// ─── Material Sourcing QC ──────────────────────────────────────────────────

export function fetchPendingMaterials() {
  return qc('/materials/pending');
}

export function submitMaterialDecisions(decisions) {
  return qc('/materials/submit', { method: 'PUT', body: decisions });
}

// ─── Space Planning QC ──────────────────────────────────────────────────────
// Reviewed one household at a time -- phonenumber is entered by the
// reviewer on the QC home screen and travels through the URL down to
// here (see SpacePlanningQc.jsx and QcHome.jsx).

export function fetchPendingSpacePlanning(phonenumber) {
  return qc(`/space-planning/pending?phonenumber=${encodeURIComponent(phonenumber)}`);
}

export function submitSpacePlanningDecisions(decisions) {
  return qc('/space-planning/submit', { method: 'PUT', body: decisions });
}

// ─── Management Dashboard ───────────────────────────────────────────────────
// Total accounts per day for the last 2 months (Singapore days).
// Reply: { timezone, from, to, totalBefore, days: [{ date, newAccounts, totalAccounts }] }

export function fetchAccountsDaily() {
  return qc('/management/accounts-daily');
}

// The furniture-piece image catalog is shared data served at
// /api/space-planning/furniture-pieces (see SpacePlanningController).
// SecurityConfig lets both customer and QC tokens read it.
export function fetchFurniturePieces() {
  return apiFetch('/api/space-planning/furniture-pieces', { area: 'qc' });
}
